export function removeEmptyProp(params: object): object {
  return Object.keys(params).reduce((final, key) => ({ ...final, ...(params[key] !== undefined ? { [key]: params[key] } : {}) }), {})
}
